module.exports = __webpack_public_path__ + "static/media/profil-radio.ab7d662f.png";